import { TipoConteudo } from 'src/app/model/arquivo.model';
import { Component, OnInit, Injector } from '@angular/core';
import { AcompanhamentoProcessualService } from './acompanhamento-processual.service';
import { JanelaAcompanhamentoProcessual } from '../../../model/acompanhamento-processual.model';
import { ProtocoloArquivoService } from '../../../shared/services/protocolo-arquivo.service';
import { BnLoadingService } from '@bndes/bndes-ux4/bndes-angular-utils';
import { BnUsuarioService } from '@bndes/bndes-ux4/bn-usuario';

@Component({
    selector: 'app-acompanhamento-processual-envio',
    templateUrl: './acompanhamento-processual-envio.component.html',
    standalone: false
})
export class AcompanhamentoProcessualEnvioComponent implements OnInit {

  titulo = 'Envio de posição da carteira em recuperação de crédito';
  instrucoesEnvio = 'Envie um arquivo com posição da carteira em recuperação de crédito.';
  tipoConteudoArquivo = TipoConteudo.ACOMPANHAMENTO_PROCESSUAL;

  public janelaAtual: JanelaAcompanhamentoProcessual;
  private permiteForaJanela;
  private cnpjUsuario?:string;

  constructor(protected injector: Injector,
  private acompanhamentoProcessualService: AcompanhamentoProcessualService,
  private protocoloArquivoService: ProtocoloArquivoService,
  private loadingService: BnLoadingService,
  private bnUsuarioService: BnUsuarioService) {
  }

  

ngOnInit() {

 this.bnUsuarioService.usuario$.subscribe(usuario => {
      this.cnpjUsuario = usuario?.cnpj;
      
    });  
  
    this.protocoloArquivoService.getJanelaPermitirEnvio({ cnpjAgente:this.cnpjUsuario, tiposProtocolos:"6&7"})
      .subscribe(permitir => {
        this.permiteForaJanela = permitir;
       });

    this.acompanhamentoProcessualService.getJanelaAtual().subscribe((resp) => {
      this.janelaAtual = resp;
    });  
}

}
